export default "__VITE_ASSET__CUkyopaJ__"